module.exports = __webpack_public_path__ + "static/media/LogoSelfPortrait.6fd2e4ec.jpg";